import styled from "styled-components";
import { userAvatar } from "../../../assets";
import EmployeesWrapper from "../../../layout/EmployeesWrapper";
import StaffFeature from "./StaffFeature";
import EditEmployee from "./EditEmployee";
import BackButton from "../../BackButton";
import { useFetch } from "../../../api/useFetch";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import MiniLoader from "../../../utils/MIniLoader";



const EmployeeDetails = () => {

      const params = useParams();
      const { id: usertoken } = params;

      let payload = { usertoken };

      const {
            loading: staffLoading, data: staffData, fetchData: getStaffData
      } = useFetch('/staff.Data', payload);

      const { fullname, email, phone, photo, } = {} = staffData;

      useEffect(() => {
            usertoken && getStaffData();
      }, [usertoken]);


      return (
            <EmployeesWrapper
                  title={''}
            >
                  <StyledEmployeeDetails>

                        <div className="col-md-9 mx-auto">

                              <BackButton />
                              <div className="main-container px-0">
                                    <div className="text-center">
                                          <div className="d-flex align-items-center justify-content-center">
                                                <h5 className=""> Edit Employee </h5>
                                                <MiniLoader
                                                      load={staffLoading}
                                                />
                                          </div>


                                          <div className="img-container mx-auto">
                                                <img src={photo || userAvatar} alt={'fullname'} />
                                          </div>

                                          <div className="my-3 fw-bold pry-bold-text">
                                                <h5 className="m-0">
                                                      {fullname || 'Nil'}
                                                </h5>
                                                <small className="">
                                                      {email || 'Nil'}
                                                </small>
                                                <div className="border border-primary py-1 px-2 fit-content mx-auto br-sm mt-2">
                                                      CEO
                                                </div>
                                          </div>

                                          <div className="row mt-5 w-100 m-0">
                                                <div className="col-lg-6 p-0">
                                                      <div className="sec-bold pry-bold-text fw-bold py-1 px-2 mx-auto  mt-2">
                                                            Employee Details
                                                      </div>

                                                      <div className="container">
                                                            <EditEmployee
                                                                  data={staffData || []}
                                                            />
                                                      </div>
                                                </div>
                                                <div className="col-lg-6 p-0">
                                                      <div className="sec-bold pry-bold-text fw-bold py-1 px-2 mx-auto  mt-2">
                                                            Employee Access
                                                      </div>

                                                      <div className="container">
                                                            <StaffFeature

                                                            />
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>

                  </StyledEmployeeDetails>
            </EmployeesWrapper>
      );
};

export default EmployeeDetails;


const StyledEmployeeDetails = styled.section`
      
.img-container {
  border-radius: 5rem !important;
  width: 9rem !important;
  height: 9rem !important;
  padding: 0 !important;
  padding-bottom: 1rem !important;
  display: flex !important;
  margin-top: 1rem !important;
  
  
  img {
   border-radius: 5rem !important;
 }
}

`;